import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMde, { ReactMdeTypes } from 'react-mde';
import Showdown from 'showdown';
import { addField } from 'react-admin';
require('react-mde/lib/styles/css/react-mde-all.css');

export interface MarkdownEditorProps { }

export interface MarkdownEditorState {
    mdeState: ReactMdeTypes.MdeState;
}

class MarkdownEditor extends Component<MarkdownEditorProps, MarkdownEditorState> {

    converter: Showdown.Converter;
    constructor(props) {
        super(props);
        this.state = {
            mdeState: { markdown: props.input.value }
        };


        this.converter = new Showdown.Converter({
            tables: true,
            simplifiedAutoLink: true,
            strikethrough: true,
            openLinksInNewWindow: true,
            tasklists: true
          });
    }
    handleValueChange = (mdeState: ReactMdeTypes.MdeState) => {
        this.setState({ mdeState });
        this.props.input.onChange(this.state.mdeState.markdown);
    };

    render() {
        return <ReactMde
            editorState={this.state.mdeState}
            onChange={this.handleValueChange}
            layout='tabbed'
            generateMarkdownPreview={(markdown) => Promise.resolve(this.converter.makeHtml(markdown))}
        />
    }
}

MarkdownEditor.propTypes = {
    addField: PropTypes.bool.isRequired,
    addLabel: PropTypes.bool.isRequired,
    input: PropTypes.object,
    label: PropTypes.string,
    options: PropTypes.object,
    source: PropTypes.string
};

MarkdownEditor.defaultProps = {
    addField: true,
    addLabel: false,
    options: {},
    record: {}
};

export default addField(MarkdownEditor);


// WEBPACK FOOTER //
// ./src/components/input/MarkdownEditor.js